// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ICensusRequestAcceptedDto
 */
export interface ICensusRequestAcceptedDto {
    /**
     * 
     * @type {number}
     * @memberof ICensusRequestAcceptedDto
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof ICensusRequestAcceptedDto
     */
    records_accepted?: number;
}

/**
 * Check if a given object implements the ICensusRequestAcceptedDto interface.
 */
export function instanceOfICensusRequestAcceptedDto(value: object): value is ICensusRequestAcceptedDto {
    return true;
}

export function ICensusRequestAcceptedDtoFromJSON(json: any): ICensusRequestAcceptedDto {
    return ICensusRequestAcceptedDtoFromJSONTyped(json, false);
}

export function ICensusRequestAcceptedDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICensusRequestAcceptedDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'records_accepted': json['recordsAccepted'] == null ? undefined : json['recordsAccepted'],
    };
}

export function ICensusRequestAcceptedDtoToJSON(json: any): ICensusRequestAcceptedDto {
    return ICensusRequestAcceptedDtoToJSONTyped(json, false);
}

export function ICensusRequestAcceptedDtoToJSONTyped(value?: ICensusRequestAcceptedDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'recordsAccepted': value['records_accepted'],
    };
}

